import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const LS_KEY = "staffToken";

export default function StaffGuard({ children }) {
  const token = typeof window !== "undefined" ? localStorage.getItem(LS_KEY) : null;
  const location = useLocation();
  const [verified, setVerified] = useState(false);
  const [rejected, setRejected] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!token) {
      setRejected(true);
      setVerified(false);
      return () => {
        cancelled = true;
      };
    }

    fetch("/staff/ping", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        if (!cancelled) {
          setVerified(true);
          setRejected(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          localStorage.removeItem(LS_KEY);
          setVerified(false);
          setRejected(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token) {
    const qs = new URLSearchParams({ returnTo: location.pathname + location.search });
    return <Navigate to={`/staff/login?${qs.toString()}`} replace />;
  }
  if (rejected) {
    const qs = new URLSearchParams({ returnTo: location.pathname + location.search });
    return <Navigate to={`/staff/login?${qs.toString()}`} replace />;
  }
  if (!verified) {
    return <div className="p-6 text-sm text-gray-600">Verifying staff session...</div>;
  }
  return children;
}
